module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Manager"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("管理员账号管理")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addManager(2)
      }
    }
  }, [_vm._v("新增学校管理员")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addManager(4)
      }
    }
  }, [_vm._v("新增场馆管理员")])], 1), _vm._v(" "), _c('div', {
    staticClass: "selectSchool"
  }, [_c('el-select', {
    staticClass: "selectInput",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入高校名称",
      "loading": _vm.loading
    },
    on: {
      "change": _vm.seletedschool
    },
    model: {
      value: (_vm.region),
      callback: function($$v) {
        _vm.region = $$v
      },
      expression: "region"
    }
  }, _vm._l((_vm.option), function(item) {
    return _c('el-option', {
      key: item.firstLetter,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticClass: "roleType",
    on: {
      "change": _vm.seletedschool
    },
    model: {
      value: (_vm.roleType),
      callback: function($$v) {
        _vm.roleType = $$v
      },
      expression: "roleType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部身份",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "学校管理员",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "场馆管理员",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "班级管理员",
      "value": "5"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.managerData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "prop": "index",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "campusName",
      "label": "高校名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "账号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "身份",
      "width": "200"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.roleType == 2) ? _c('span', [_vm._v("学校管理员")]) : _vm._e(), _vm._v(" "), (_vm.row.roleType == 4) ? _c('span', [_vm._v("场馆管理员")]) : _vm._e(), _vm._v(" "), (_vm.row.roleType == 5) ? _c('span', [_vm._v("班级管理员")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.row.roleType == 5) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.editClass(_vm.row)
              }
            }
          }, [_vm._v("编辑班级\n            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.editManager(_vm.row)
              }
            }
          }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.deleteManager(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.addRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号",
      "prop": "name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称",
      "prop": "showname",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.showname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "showname", $$v)
      },
      expression: "addForm.showname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "pass", $$v)
      },
      expression: "addForm.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "repass",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.repass),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "repass", $$v)
      },
      expression: "addForm.repass"
    }
  })], 1), _vm._v(" "), (_vm.addType == 5) ? _c('el-form-item', {
    attrs: {
      "label": "行政班级:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.checkAll
    },
    model: {
      value: (_vm.isCheckAll),
      callback: function($$v) {
        _vm.isCheckAll = $$v
      },
      expression: "isCheckAll"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全选")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addType == 5) ? _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "depart",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.addForm.depart),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "depart", $$v)
      },
      expression: "addForm.depart"
    }
  }, _vm._l((_vm.departs), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "value": "item.id"
      }
    }, [_vm._v("\n              " + _vm._s(item.department))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addNewManager.apply(null, arguments)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.editRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号",
      "prop": "name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "pass", $$v)
      },
      expression: "editForm.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "repass",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.repass),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "repass", $$v)
      },
      expression: "editForm.repass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editPass.apply(null, arguments)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-732923cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/Manager.vue
// module id = 1071
// module chunks = 0